import { useRef, useEffect, useCallback } from 'react';

function useDebouncedCallback(callback, delay) {
  const debouncedFunction = useRef(callback);
  debouncedFunction.current = callback;
  const functionTimeoutHandler = useRef(null);
  const isComponentUnmounted = useRef(false);
  useEffect(() => () => {
    isComponentUnmounted.current = true;
  }, []);
  const debouncedCallback = useCallback((...args) => {
    clearTimeout(functionTimeoutHandler.current);
    functionTimeoutHandler.current = window.setTimeout(() => {
      if (!isComponentUnmounted.current) {
        debouncedFunction.current(...args);
      }
    }, delay);
  }, [delay]);
  return debouncedCallback;
}

export { useDebouncedCallback };
//# sourceMappingURL=useDebouncedCallback.es.js.map
